// deliveryZonesApi.ts
import { http } from "./http";

// ✅ Fetch all delivery zones
export const getDeliveryZones = async () => {
  const res = await http.get("/api/delivery-zones");
  return res.data;
};

// ✅ Create a new delivery zone (city-based)
export const createDeliveryZone = async (zone: {
  name: string;
  city: string;
  fee_cents: number;
  active: boolean;
}) => {
  const res = await http.post("/api/delivery-zones", zone);
  return res.data;
};

// ✅ Update an existing delivery zone
export const updateDeliveryZone = async (id: number, zone: any) => {
  const res = await http.put(`/api/delivery-zones/${id}`, zone);
  return res.data;
};

// ✅ Delete a delivery zone
export const deleteDeliveryZone = async (id: number) => {
  const res = await http.delete(`/api/delivery-zones/${id}`);
  return res.data;
};